var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card"},[_c('div',{staticClass:"card-body"},[_c('b-row',[_c('b-col',{staticClass:"pt-1",attrs:{"xl":"3","lg":"3","md":"6","sm":"12"}},[_c('market-place-component',{on:{"input":_vm.handleMarketplace}})],1)],1)],1)])}
var staticRenderFns = []

export { render, staticRenderFns }